import Divider from './Divider'

export default Divider



// WEBPACK FOOTER //
// ./src/components/Divider/index.js